import {  util, loader, native, webviewInfo,bridge } from '@ali/amap-lib';
import CONFIG_URLS from '../../config/config.aos';
import CONFIG_ACT from '../../config/config.act';
import { EventBus } from './event-bus';

/**
 *
 * @type {String|Object}
 */
// todo
const asac = util.getUrlParam('asac') || '2A21910LPU81JF30GU0FSD';

/**
 * 运营统一请求函数，无需关注端内端外环境
 * @param {string} [method = get] - 请求方法
 * @param {string} url - 请求 URL
 * @param {array} params - 请求参数
 * @returns {Promise<any>}
 */
const myLoader = (() => {
  const requestHandler = loader;
  return (method = 'get', url, params) => {
    const isInAmap = webviewInfo.isInAmap();
    if (!url) {
      return Promise.reject(new Error('请求地址不存在.'));
    }

    return new Promise((resolve, reject) => {
      let handler = requestHandler.aosJsonp;

      if (isInAmap) {
        handler = requestHandler[method];
        method = () => { };
      }
      handler(
        url,
        params,
        response => {
          console.log('[AOS请求] ', url, params);
          console.log('[AOS响应] ', response);
          if (
            response &&
            response.code &&
            parseInt(response.code.toString(), 10) === 1
          ) {
            const { data } = response;
            const { timestamp } = response;
            // 派发时间
            if (timestamp && CustomEvent) {
              const myEvent = new CustomEvent('serverTimeUpdate', {
                detail: {
                  timestamp: parseInt(timestamp)
                }
              });

              window.dispatchEvent(myEvent);
            }
            resolve({ ...data, timestamp });
          } else {
            reject({ ...response, aosurl: url });
          }
        },
        method,
        false,
        true, // WUA
        {asac} // asac
      );
    });
  };
})();

const sign = 1;

const service = {
  // ============= native action 封装 ============
  /**
   * 获取 user id
   * @param {boolean} onlyGetId - 只获取用户 ID 不会打开登陆面板
   * @param {boolean} needRelogin - 强制重新登陆
   * @returns {Promise<any>}
   */
  getUserId(onlyGetId = false, needRelogin = false) {
    return new Promise((resolve, reject) => {
      EventBus.$emit('client.login');

      native.getUserId(
        data => {
          const userId = data.userid;
          console.log(222, data)
          if (!userId) {
            reject(data);
          } else {
            resolve(userId);
          }
        },
        onlyGetId,
        needRelogin
      );
    });
  },
  /**
   * 获取 tid
   * @returns {Promise<any>}
   */
  getAppInfo() {
    return new Promise((resolve, reject) => {
      native.getAppInfo(data => {
        // 添加 data 为空的判断
        if (data && data.tid) {
          const { tid } = data;
          resolve(tid);
        } else {
          reject(data);
        }
      });
    });
  },
  /**
   * 对比高德 App 的版本
   * @param {string} version - 传入的高德 App 版本
   * @returns {Promise<boolean>}
   */
  compareAppVersion(version = '080900') {
    return new Promise(resolve => {
      native.compareDiv(version, res => {
        // console.log(res,'版本');
        resolve(res);
      });
    });
  },
  /**
   * 获取 getMapLocation
   * @returns {Promise<any>}
   */
  getMapLocation() {
    return new Promise((resolve, reject) => {
      native.getMapLocation(location => {
        // console.log('[location]', location);
        resolve(location);
      });
    });
  },
  // ============ 分享相关接口 ============
  /**
   * 长链接转短链接
   * @param {string} address -
   */
  transform(address) {
    const params = [
      {
        flag: 1,
        sign
      },
      {
        address,
        sign
      },
      {
        appfrom: 'operation'
      }
    ];
    return new Promise((resolve, reject) => {
      loader.post(
        CONFIG_URLS.transform,
        params,
        res => {
          if (+res.code === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        false,
        false
      );
    });
  },
  /**
   * 端外落地页分享配置
   * @param tid
   * @param with_user
   * @return {Promise<never> | Promise<unknown>}
   */
  shareConfOut(activity) {
    return myLoader('post', CONFIG_URLS.external_share, [
      {
        activity,
      },
    ]);
  },
  /**
   * 获取分享的配置数据
   * @param {string} tid - 设备 tid
   * @param {string} activity - 活动标识
   * @param {number} [with_user=0||1]
   * @return {Promise<any>}
   */
  shareConf(tid, activity, with_user = 0) {
    return myLoader('post', CONFIG_URLS.share_conf, [
      {
        tid,
        sign
      },
      {
        activity
      },
      {
        with_user
      }
    ]);
  },
  /**
   * 本方法给 common share 组件使用，误删除
   * @link shareConf
   * @param {Array} params
   * @return {Promise<any>}
   */
  getShareConf(params) {
    return myLoader('post', CONFIG_URLS.share_conf, params);
  },
  /**
   * base64生成在线地址
   * @param {string} tid
   * @param {string} image_data
   * @return {Promise<string>}
   */
  createImage(tid, image_data) {
    return myLoader('post', CONFIG_URLS.create_image, [
      {
        tid,
        sign
      },
      {
        image_data
      }
    ]);
  },
  /**
   * 口令分享
   * @param {string} tid
   * @param {string} act
   * @param {string} biz_param
   * @return {Promise<Object>}
   */
  shareCommand(tid, act, biz_param) {
    return myLoader('post', CONFIG_URLS.share_command, [
      {
        tid,
        sign
      },
      {
        source: act || CONFIG_ACT.activity,
        sign
      },
      {
        biz_param
      }
    ]);
  },
  /**
   * 端内邀请好友
   * @param {string} tid - 设备 tid
   * @param {string} activity - 活动标识
   * @param {string} friend_uid - 好友的 uid
   * @returns {Promise<any>}
   */
  invite(tid, activity, friend_uid = '') {
    return myLoader('post', CONFIG_URLS.invite, [
      {
        tid,
        sign
      },
      {
        activity: activity || CONFIG_ACT.activity
      },
      {
        friend_uid: friend_uid || ''
      },
      {
        scene: 1
      }
    ]);
  },
  /**
   * 好友列表
   * @param
   */
  friendList(param) {
    return myLoader('post', CONFIG_URLS.friend_list, param)
  },
  // ========== ==========
  /**
   * @param {Number} time - delay 的时间，单位为 ms
   * @return {Promise<>}
   */
  sleep(time = 2000) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  },
  // =========== 业务接口 ============
  // ！！！请勿在此继续编写业务接口代码，请使用下方封装的install方法在其他文件内动态的为service类扩充方法！！！
};

/**
 * 向 service 内部注入函数
 * @param fn {function} 注入的函数
 * @param name {string}
 * @private
 */
service._install = (fn, name) => {
  let key = name || fn.name;
  if (typeof fn === 'function' && !service[key]) {
    service[key] = fn;
  }
};

/**
 *
 * @type {function(*=, *=, *=): (Promise<never>)}
 * @private
 */
service._loader = myLoader;

export default service;
